export default __webpack_public_path__ + "static/media/words4.9b97d388.png";